module.exports = __webpack_public_path__ + "static/media/newsletter-may-2021-archbishop-benjamin-message.49caa1a4.jpg";